// API Status
export const OK = "OK";
export const CLIENTERROR = "ClientError";

// API stuff - Cover and Payment
export const INCLUDED = "Included";
export const EXCLUDED = "Excluded";
export const NOTAPPLICABLE = "NotApplicable";
export const ANNUAL = "Annual";
export const MONTHLY = "Monthly";
export const MONTHLY_3_MONTHS_DEFERRED = "Monthly3MonthsDeferred";
export const MONTHLY_2_MONTHS_FREE = "Monthly2MonthsFree";
export const DIRECTDEBIT = "DirectDebit";

// Quote Status
export const PREQUOTE = "PREQUOTE";
export const PRICED = "PRICED";
export const FAILED = "FAILED";
export const UNABLE = "UNABLE";
export const SUBMITTED = "SUBMITTED";

// API quote status
export const INPROGRESS = "INPROGRESS";
export const QUOTESRETRIEVED = "QUOTESRETRIEVED";
export const UNABLETOQUOTE = "UNABLETOQUOTE";
export const QUICKQUOTERETRIEVED = "QUICKQUOTERETRIEVED";
export const PROCEEDED = "PROCEEDED";

// API QuickQuoteStatus
export const FULLQUOTESRETRIEVED = "FULLQUOTESRETRIEVED";

export const COVERTYPE = {
  BuildingsAndContents: "BuildingsAndContents",
  BuildingsOnly: "BuildingsOnly",
  ContentsOnly: "ContentsOnly",
  Disability: "Disability",
  UnemploymentAndDisability: "UnemploymentAndDisability",
};

export const COVERTYPE_TEXT = {
  BuildingsAndContents: "Buildings & Contents",
  BuildingsOnly: "Buildings only",
  ContentsOnly: "Contents only",
};

// NCD States
export const CLEAN = "CLEAN";
export const DEFAULTED = "DEFAULTED";

export const TOOL_TIP_TEXT = {
  Buildings:
    "The sum insured must cover the cost of rebuilding your home. The value of your home including the land is not an accurate sum insured for the actual replacement value of the building.",
  Contents:
    "The Contents sum insured must be enough to cover the full replacement cost of all the contents in your home as new. Contents Insurance includes household goods such as furniture, carpets, jewellery and clothing. We provide a choice of either £75,000 or £100,000 for owner occupied properties. For tenants we provide a contents sum insured of £20,000, £30,000, £40,000 or £50,000.",
  HomeEmergency:
    "Please indicate if you would like to add Home Emergency cover to your policy. A Home Emergency is a sudden or unexpected event in the home which requires immediate action to:<ul><li>Make the home safe and secure.</li><li>Avoid damage or further damage.</li><li>Relieve unreasonable discomfort and risk of difficulty for the customer and their family.</li><li>Restore electricity, gas or water services to the property if they have totally failed.</li></ul>",
  LegalExpenses:
    "Please indicate if the customer would like to add Legal Expenses cover to their policy. Legal expenses cover provides you and your family for up to £100,000 of cover per insured incident to pursue or defend a claim including employment disputes, bodily injury claims or contract disputes relating to the sale or purchase of goods and services.",
  PremiumFlex:
    "Please enter the amount by which you'd like to flex the premium. You can also flex this up or down in increments of 0.1 using the + or - buttons. NOTE: If you choose to flex the premium, your commission for this case will be paid on an Annual Indemnity basis.",
  BuildingStandardCover:
    "<p>As standard you will be covered for accidental damage to service pipes and cables, glass in your windows and sanitary fittings (for example, baths, shower trays, sinks). Damage caused by chewing, scratching, tearing or fouling by pets and the cost of routine maintenance, is not covered.</p> <p>Please see the policy terms and conditions for further information on accidental damage. These can be found within the Paymentshield website.</p>",
  BuildingExtraCover:
    "<p>If you have selected extra accidental damage, this covers the rest of your building for events such as putting your foot through the ceiling or hammering a nail through a hidden water pipe. Damage caused by chewing, scratching, tearing or fouling by pets and the cost of routine maintenance, is not covered.</p> <p>Please see the policy terms and conditions for further information on accidental damage. These can be found within the Paymentshield website.</p>",
  ContentsStandardCover:
    "<p>As standard, you will be covered for accidental damage to televisions, computer equipment (including laptops and tablets), games consoles, mirrors and fixed glass in furniture (such as a glass coffee table). Damage to clothing or damage due to mechanical or electrical breakdown is not covered.</p> <p>Please see the policy terms and conditions for further information on accidental damage. These can be found within the Paymentshield website.</p>",
  ContentsExtraCover:
    "<p>If you have selected extra accidental damage, cover will be extended to include accidental damage to most contents.  For example, spilling red wine or paint on a carpet. Damage to clothing or damage due to mechanical or electrical breakdown is not covered.</p> <p>Please see the policy terms and conditions for further information on accidental damage. These can be found within the Paymentshield website.</p>",
  RentProtection:
    "<p>Rent Protection covers you for up to £2,500 per month, for up to 6 months, to protect against rent arrears due from a tenant under the tenancy agreement. It also provides tenant eviction cover, up to £100,000. This is for legal costs and disbursements incurred in evicting a tenant from the property, subject to certain conditions.</p>",
};

export const APPLICATION_STEPS = {
  coverDetails: 0,
  yourDetails: 1,
  propertyDetails: 2,
  yourQuotes: 3,
  yourApplication: 4,
  payment: 5,
  applicationSuccess: 6,
};

export const STEP_TITLE = {
  yourDetails: "Your details",
  propertyDetails: "Property details",
  yourQuotes: "Your quotes",
  yourQuote: "Your quote",
  yourApplication: "Your application",
  payment: "Payment",
};

export const STEP_MAP = [
  {
    sectionTitle: STEP_TITLE.yourDetails,
    stepNumber: APPLICATION_STEPS.yourDetails,
  },
  {
    sectionTitle: STEP_TITLE.propertyDetails,
    stepNumber: APPLICATION_STEPS.propertyDetails,
  },
  {
    sectionTitle: STEP_TITLE.yourApplication,
    stepNumber: APPLICATION_STEPS.yourApplication,
  },
  {
    sectionTitle: STEP_TITLE.payment,
    stepNumber: APPLICATION_STEPS.payment,
  },
];

export const FIRST_TIME_BUYER_NCD = "Two";

export const CALL_CHANNEL = {
  intrinsic: "Intrinsic",
  advised: "Advised",
  referralTelephony: "ReferralTelephony",
  referralSelfServe: "ReferralSelfServe",
};

export const EXIT_DESTINATION = {
  adviserHub: "EXIT_TO_ADVISERHUB",
  d2cHomePage: "EXIT_TO_D2C_HOMEPAGE",
  landlordWelcomePage: "EXIT_TO_D2C_LANDLORD_WELCOME_PAGE",
};

export const D2C_COM_TYPE = {
  quoteReference: "QuoteReference",
  finishQuote: "FinishQuote",
};

export const PS_DEFAULT_OPTIONS = {
  suppressScrollX: true,
};

export const AGE_FOR_APPLICATION = {
  min: 18,
  max: 110,
};

export const PRODUCT = {
  HomeOld: 1008,
  Home: 1015,
  LandLord: 1009,
  Tenants_Contents: 1014,
  Tenants_Liability: 1010,
  MPPI: 1003,
  Rent_Protection: 1011,
};

export const LANDLORD_TYPE = {
  Company: "Company",
  LandLord: "LandLord",
};

export const INSURED_PARTY = {
  Business: "Business",
  Individual: "Individual",
  PrivateLandlord: "PrivateLandlord",
  LettingAgent: "LettingAgent",
};

export const FILE_KEY = {
  suitabilityReport: "suitability",
  quoteAndApplicationDetails: "qas",
  statementDemands: "sdn",
  factfindStatementDemands: "factfindsdn",
  quoteResultsSummary: "multiquote",
};
export const IDLE_TIME = 45 * 60 * 1000;

export const HOT_JAR_ID = { D2C: "3612749", DIRECT: "3330988" };
export const EMAIL_CONTACT_US = "enquiries@paymentshield.co.uk";
export const RQS_SYSTEM_ID = "941c0b43-2ffd-4a7e-8684-c081ec2e691e";

export const PHONE_NUMBER_VMASK = "#### ### ####";
export const DOC_DELIVERY_PREF = {
  Online: "Online",
  Postal: "Postal",
};

export const PRODUCT_WHY_PAYMENTSHIELD_POPUP = {
  [PRODUCT.Home]: "Home",
  [PRODUCT.LandLord]: "Landlords",
  [PRODUCT.Tenants_Contents]: "Tenants_Contents",
};
